import React from 'react'
import {IOVF} from '~/fonts/IOVF'

export default function IO(props: React.HTMLAttributes<HTMLSpanElement>) {
  return (
    <span {...props} className={IOVF.className}>
      IO
    </span>
  )
}
